export function TokenDonut({ pct, size = 88 }: { pct: number; size?: number }) {
  const clamped = Math.max(0, Math.min(100, pct))
  const r = 36
  const c = 2 * Math.PI * r
  const offset = c - (clamped / 100) * c
  return (
    <svg width={size} height={size} viewBox="0 0 88 88" className="shrink-0" aria-hidden>
      <circle cx="44" cy="44" r={r} fill="none" className="stroke-border" strokeWidth="8" />
      <circle
        cx="44"
        cy="44"
        r={r}
        fill="none"
        className="stroke-primary"
        strokeWidth="8"
        strokeLinecap="round"
        strokeDasharray={c}
        strokeDashoffset={offset}
        transform="rotate(-90 44 44)"
      />
      <text
        x="44"
        y="48"
        textAnchor="middle"
        className="fill-foreground text-[14px] font-semibold"
        style={{ fontSize: 14, fontWeight: 600 }}
      >
        %{clamped}
      </text>
    </svg>
  )
}
